'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_DocumentsAuditLogListRequest(docId, pageCursor) {
  this.a6P = null;
  this.a6Q = null;
  this.a6P = docId;
  this.a6Q = pageCursor;
}
export { $c_Lapp_api_DocumentsAuditLogListRequest as $c_Lapp_api_DocumentsAuditLogListRequest };
$p = $c_Lapp_api_DocumentsAuditLogListRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_DocumentsAuditLogListRequest;
/** @constructor */
function $h_Lapp_api_DocumentsAuditLogListRequest() {
}
export { $h_Lapp_api_DocumentsAuditLogListRequest as $h_Lapp_api_DocumentsAuditLogListRequest };
$h_Lapp_api_DocumentsAuditLogListRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DocumentsAuditLogListRequest)) {
    var x = this.a6P;
    var x$2 = x$0.a6P;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.a6Q;
      var x$4 = x$0.a6Q;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentsAuditLogListRequest";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.a6P;
  }
  if ((n === 1)) {
    return this.a6Q;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "docId";
  }
  if ((n === 1)) {
    return "pageCursor";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_DocumentsAuditLogListRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.im)));
}
export { $isArrayOf_Lapp_api_DocumentsAuditLogListRequest as $isArrayOf_Lapp_api_DocumentsAuditLogListRequest };
var $d_Lapp_api_DocumentsAuditLogListRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_DocumentsAuditLogListRequest, "app.api.DocumentsAuditLogListRequest", ({
  im: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_DocumentsAuditLogListRequest as $d_Lapp_api_DocumentsAuditLogListRequest };
//# sourceMappingURL=app.api.-Documents-Audit-Log-List-Request.js.map
